export function join (...urls) {
  return urls.map(url => {
    if(url){
      return url.replace(/(^\/)|(\/$)/g, '')
    }
  }).join('/')
}

export default {
  join
}
